/** api_match sentinel from national sync when player is not in WC squad */
export const NOT_CALLED_UP_MATCH_ID = 'NOT_CALLED_UP';
export const NOT_CALLED_UP_LABEL = 'NON CONVOCATO';

export function isNotCalledUpMatch(match) {
  if (!match) return false;
  if (match.notCalledUp === true) return true;
  const id = match.id != null ? String(match.id) : '';
  const competition = (match.competition || '').toString().trim().toUpperCase();
  return id === NOT_CALLED_UP_MATCH_ID || competition === NOT_CALLED_UP_LABEL;
}

/** Tornei gameweek Mondiale (nome come in DB: "World Cup Tournament …"). */
export function isWorldCupTournament(tournament) {
  const name = (tournament?.name || '').trim();
  return /^World Cup Tournament/i.test(name);
}

/** Sync nazionale: solo segnaposto NON CONVOCATO in api_match (nessuna partita reale). */
export function isExplicitlyNotConvocated(card) {
  const slots = [
    card?.upcoming_match_first,
    card?.upcoming_match_second,
    card?.next_match,
  ].filter(Boolean);
  if (slots.length === 0) return false;
  return slots.every((m) => isNotCalledUpMatch(m));
}

/** Etichetta Match 1 nello schieramento (null → UI mostra "N/A"). */
export function formatUpcomingMatchFirstLabel(card) {
  const m = card?.upcoming_match_first;
  return m?.utcDate ? new Date(m.utcDate).toLocaleString() : null;
}

/** True se Match 1 nello schieramento sarebbe "N/A" (nessuna prossima partita nota). */
export function isMissingUpcomingMatchFirst(card) {
  return !formatUpcomingMatchFirstLabel(card);
}

/**
 * Nel modale formazione: nasconde le card senza Match 1 (N/A).
 * Eccezioni: slot legend/divinity; card già in formazione (per poterle vedere/rimuovere).
 */
export function filterFormationCardsWithoutNa(
  cards,
  { isLegendSlot = false, teamCardIds = [] } = {}
) {
  if (!Array.isArray(cards)) return cards;
  if (isLegendSlot) return cards;
  const keep = new Set(
    (teamCardIds || []).map((id) => Number(id)).filter((id) => Number.isFinite(id))
  );
  return cards.filter(
    (card) => keep.has(Number(card.id)) || !isMissingUpcomingMatchFirst(card)
  );
}

/** Id carte già in formazione (o in selezione multipla) da non nascondere nel modale. */
export function collectFormationTeamCardIds(team, pendingLineSelection) {
  if (!team) return [];
  const reserves = team.reserves || {};
  return [
    team.goalkeeper?.id,
    ...(team.defenders || []).map((c) => c?.id),
    ...(team.midfielders || []).map((c) => c?.id),
    ...(team.attackers || []).map((c) => c?.id),
    team.legend?.id,
    reserves.RES1?.id,
    reserves.RES2?.id,
    reserves.RES3?.id,
    ...(pendingLineSelection?.selected || []).map((c) => c?.id),
  ].filter((id) => id != null);
}

/**
 * In formazione Mondiale: solo convocati con almeno una partita (next/in progress/last)
 * che cade nella finestra start_date–end_date del torneo/gameweek (playsInRange === true).
 */
export function filterWorldCupConvocatedCards(cards, tournament) {
  if (!isWorldCupTournament(tournament) || !Array.isArray(cards)) return cards;
  return cards.filter(
    (card) => !isExplicitlyNotConvocated(card) && card.playsInRange === true
  );
}
